import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/shared/constants/queryKeys';

import { getBanner } from '@/services/home';

const useAdvertisementBanner = () => {
  const { data: advertisement } = useQuery({
    queryKey: [queryKeys.banner],
    queryFn: getBanner,
    select: ({ data }) => data[0],
  });

  return { advertisement };
};

export default useAdvertisementBanner;
